'use client'
import { useState } from 'react'
import Image from 'next/image'

interface Props {
  url: string
  username: string
  size?: number  // px, default 32
  className?: string
}

export default function Avatar({ url, username, size = 32, className = '' }: Props) {
  const [errored, setErrored] = useState(false)
  const initial = username[0]?.toUpperCase() ?? '?'
  const px = `${size}px`

  if (errored) {
    return (
      <span
        className={`flex items-center justify-center rounded-full bg-indigo-600 text-white font-bold select-none shrink-0 ${className}`}
        style={{ width: px, height: px, fontSize: size * 0.4 }}
      >
        {initial}
      </span>
    )
  }

  return (
    <Image
      src={url}
      alt={username}
      width={size}
      height={size}
      style={{ width: px, height: px }}
      className={`rounded-full shrink-0 ${className}`}
      onError={() => setErrored(true)}
    />
  )
}
